import { monthName } from "components/PlanChecklistV2/ChecklistHeader/messages";
import jsPDF from "jspdf";
import moment from "moment";
import { buildReadingInterval } from "./reading";

class BuildPDF {
  constructor(readingOrder) {
    this._arrayPlan = [];
    this._paddingLeftColumnOne = this.turnEquivalent(40);
    this._paddingLeftColumnTwo = this.turnEquivalent(238);
    this._paddingLeftColumnThree = this.turnEquivalent(436);
    this._paddingTopColumns = this.turnEquivalent(120);
    this._paddingTopTitles = this.turnEquivalent(115);
    this._paddingTopSubitles = this.turnEquivalent(130);
    this._checklistRadius = this.turnEquivalent(11);
    this._lineHeight = 15;
    this._readingOrder = readingOrder;
    this._columnWidth = 90;

    this._doc = new jsPDF({
      unit: "px",
      format: "a4",
      filters: ["ASCIIHexEncode"],
    });

    this._logo =
      "data:image/png;base64,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";

    // helpers
    this._lineIndex = 0;
  }

  setArrayPlan(array) {
    this._arrayPlan = array;
  }

  getArrayPlan() {
    return this._arrayPlan;
  }

  addLogo() {
    //dividir todos os valores de px por 1.5
    this._doc.addImage(this._logo, "PNG", 180, 25, 80.6, 16.6);
  }

  createColumnTitle(title, paddingLeft, paddingTop) {
    this._doc.setFontSize(14);
    this._doc.setFont(undefined, "bold");

    this._doc.text(title, paddingLeft, paddingTop);
  }

  createColumnSubtitle(subtitle, paddingLeft, paddingTop) {
    this._doc.setFontSize(10);
    this._doc.setFont(undefined, "normal");

    this._doc.text(subtitle, paddingLeft, paddingTop);
  }

  createColumnRow(day, reading, paddingTop, paddingLeft) {
    this._doc.setFont(undefined, "normal");
    this._doc.setFontSize(10.66);

    const dateText = moment(day).date().toString();
    this._doc.text(
      dateText < 10 ? 0 + dateText : dateText,
      paddingLeft,
      paddingTop
    );

    this._doc.circle(
      paddingLeft + 20,
      paddingTop - 3,
      this._checklistRadius - 4
    );

    const availableWidth = this._columnWidth; // px, adjust as needed for your layout
    const readingLines = this._doc.splitTextToSize(reading, availableWidth);

    for (let i = 0; i < readingLines.length; i++) {
      this._doc.text(
        readingLines[i],
        paddingLeft + 37 - this._checklistRadius,
        paddingTop + i * this._lineHeight
      );
    }
  }

  createSecondColumn() {
    this._doc.setFontSize(14);
    this._doc.setFont(undefined, "bold");
    this._doc.text(
      "Fevereiro",
      this._paddingLeftColumnTwo,
      this._paddingTopTitles
    );

    this._doc.setFont(undefined, "normal");
    this._doc.setFontSize(10.66);

    for (let day = 1, count = 0; count <= 30; count++, day++) {
      this._doc.text(
        `${day < 10 ? "0" + day : day}`,
        this._paddingLeftColumnTwo,
        this._paddingTopColumns + count * this._lineHeight
      );
    }

    for (let count = 0; count <= 30; count++) {
      this._doc.circle(
        this._paddingLeftColumnTwo + 20,
        this._paddingTopColumns - 3 + count * this._lineHeight,
        this._checklistRadius - 2.5
      );
    }

    for (let count = 0; count <= 30; count++) {
      this._doc.text(
        `Tm ${count} até Tm ${count + 3}`,
        this._paddingLeftColumnTwo + 35 - this._checklistRadius,
        this._paddingTopColumns + count * this._lineHeight
      );
    }
  }

  createThirdColumn() {
    this._doc.setFontSize(14);
    this._doc.setFont(undefined, "bold");
    this._doc.text(
      "Março",
      this._paddingLeftColumnThree,
      this._paddingTopTitles
    );

    this._doc.setFont(undefined, "normal");
    this._doc.setFontSize(10.66);

    for (let day = 1, count = 0; count <= 30; count++, day++) {
      this._doc.text(
        `${day < 10 ? "0" + day : day}`,
        this._paddingLeftColumnThree,
        this._paddingTopColumns + count * this._lineHeight
      );
    }

    for (let count = 0; count <= 30; count++) {
      this._doc.circle(
        this._paddingLeftColumnThree + 20,
        this._paddingTopColumns - 3 + count * this._lineHeight,
        this._checklistRadius - 2.5
      );
    }

    for (let count = 0; count <= 30; count++) {
      this._doc.text(
        `Tm ${count} até Tm ${count + 3}`,
        this._paddingLeftColumnThree + 35 - this._checklistRadius,
        this._paddingTopColumns + count * this._lineHeight
      );
    }
  }
  // DOCUMENTATION:
  //day: 30
  // endBook: "Apocalipse"
  // endChapter: 15
  // month: "Dezembro"
  // startBook: "Apocalipse"
  // startChapter: 9

  build() {
    this.addLogo();

    let calendar = this.getArrayPlan();
    let currentRow = 0;
    let currentColumn = 0;
    let currentMonth = null;

    calendar.forEach((item, index, array) => {
      const month = monthName(moment(item.date).month());
      const year = moment(item.date).year().toString();
      const monthChanged = currentMonth !== month;

      // Handle month change
      if (monthChanged) {
        // Write month title
        const paddingLeft = this.getColumnPadding(currentColumn);
        if (currentRow !== 0) {
          currentRow += 1; // Increment for month title and year
        }
        this.createColumnTitle(
          month,
          paddingLeft,
          this._paddingTopColumns + currentRow * this._lineHeight
        );
        currentRow += 1; // Increment for month title and year

        // Write year subtitle
        this.createColumnSubtitle(
          year,
          paddingLeft,
          this._paddingTopColumns + currentRow * this._lineHeight - 5
        );
        currentRow += 1;

        currentMonth = month;
      }

      // Write day content
      const paddingLeft = this.getColumnPadding(currentColumn);
      const readingInterval = buildReadingInterval(
        item,
        true,
        this._readingOrder
      );
      const readingLines = this._doc.splitTextToSize(
        readingInterval,
        this._columnWidth
      );

      this.createColumnRow(
        item.date,
        readingInterval,
        this._paddingTopColumns + currentRow * this._lineHeight,
        paddingLeft
      );

      currentRow += readingLines.length;

      // Handle row overflow
      if (currentRow >= 34) {
        currentRow = 0;
        currentColumn++;

        // Handle column overflow
        if (currentColumn > 2) {
          currentColumn = 0;
          this._doc.addPage();
          this.addLogo();
        }
      }
    });
  }

  getColumnPadding(columnIndex) {
    switch (columnIndex) {
      case 0:
        return this._paddingLeftColumnOne;
      case 1:
        return this._paddingLeftColumnTwo;
      case 2:
        return this._paddingLeftColumnThree;
      default:
        return this._paddingLeftColumnOne;
    }
  }

  monthWillChange(item, array, index) {
    let reachLastIndex = array.length - 1 === index;

    if (!reachLastIndex) {
      let changesInNexIteraion =
        moment(array[index + 1].date).month() !== moment(item.date).month();

      return changesInNexIteraion;
    }
  }

  endPage(columnIndex) {
    return columnIndex === 2;
  }

  isSameMonth() {
    // let sameMonth = mesAtual == item.month || mesAtual == 'firstMonth';
    // // console.log(mesAtual, item.month)
    // if(sameMonth) {
    //   console.log('mesmo mes',item);
    // } else {
    //   console.log('diferent mes')
    // }
  }

  isLastPage(item, array) {
    return (
      moment(item.date).month() === moment(array[array.length - 1].date).month()
    );
  }

  createTitle(columnIndex, title, subtitle) {
    switch (columnIndex) {
      case 0:
        this.createColumnTitle(title, this._paddingLeftColumnOne);
        this.createColumnSubtitle(subtitle, this._paddingLeftColumnOne);
        break;
      case 1:
        this.createColumnTitle(title, this._paddingLeftColumnTwo);
        this.createColumnSubtitle(subtitle, this._paddingLeftColumnTwo);
        break;
      case 2:
        this.createColumnTitle(title, this._paddingLeftColumnThree);
        this.createColumnSubtitle(subtitle, this._paddingLeftColumnThree);
        break;
      default:
        break;
    }
  }

  createColumnContent(item, columnIndex, index) {
    const readingInterval = buildReadingInterval(
      item,
      true,
      this._readingOrder
    );

    switch (columnIndex) {
      case 0:
        this.createColumnRow(
          item.date,
          readingInterval,
          this._paddingTopColumns + index * this._lineHeight,
          this._paddingLeftColumnOne
        );
        break;

      case 1:
        this.createColumnRow(
          item.date,
          readingInterval,
          this._paddingTopColumns + index * this._lineHeight,
          this._paddingLeftColumnTwo
        );
        break;
      case 2:
        this.createColumnRow(
          item.date,
          readingInterval,
          this._paddingTopColumns + index * this._lineHeight,
          this._paddingLeftColumnThree
        );
        break;
      default:
        break;
    }

    // switch(column) {
    //   case 0:
    //     this.createColumn(
    //       item.day,
    //       `${item.startBook} ${item.startChapter} - ${item.endBook} ${item.endChapter}`,
    //       this._paddingTopColumns + index * this._lineHeight);
    //   break;
    //   // case 1:
    //   //   this.createSecondColumn();
    //   // break;
    //   // case 2:
    //   //   this.createThirdColumn();
    //   // break;
    // }
  }

  getBlobUrl() {
    return this._doc.output("bloburl", { filename: `BiplePlan.pdf` });
  }

  savePDF(name) {
    //  I got stuck making this work for ios and decided to postpone it
    // if (
    //   /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    //     navigator.userAgent.toLowerCase()
    //   )
    // ) {
    //   if (Capacitor.isNativePlatform()) {
    //     const blobPDF =  new Blob([ this._doc.output() ], { type : 'application/pdf'});
    //     const blobUrl = URL.createObjectURL(blobPDF);  //<--- THE ERROR APPEARS HERE
    //     console.log('blobUrl',blobUrl)

    //     return Browser.open({
    //       url: blobUrl
    //     });
    //   }

    //   window.open(this._doc.output("bloburl", { filename: `${name}.pdf` }));
    // } else {
    //   this._doc.save(`${name}.pdf`);
    // }
    this._doc.save(`${name}.pdf`);
  }

  turnEquivalent(px) {
    return px / 1.5;
  }
}

export default BuildPDF;
